// @utilities
const apiURLBuilder = require('core/apiURLBuilder');
const { APIPost } = require('utilities/APIRequestHelper');
//@actions
const signaturePatternActions = require('actions/signaturePattern');
//@constants
const actionTypes = require('constants/actionTypes');

const setLimit = limit => ({
    type: actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_SET_LIMIT,
    payload: {
        limit
    }
})

const setVisibleStep = step => ({
    type: actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_SET_VISIBLE_STEP,
    payload: {
        step
    }
})

const validateStep = step => (dispatch, getState) => {
    dispatch({
        type: actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_VALIDATE_STEP,
        payload: {
            step
        }
    });
    const valid = getState().creditPregrantedLimitVariation.getIn(['steps', 0, 'valid']);

    if (valid) {
        dispatch(setVisibleStep(2));
    }
}

const setWillCancel  = willCancel => ({
    type: actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_WILL_CANCEL,
    payload: {
        willCancel
    }
})

const clear = () => ({
    type: actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_CLEAR
})

const changeLimitRequest = () => ({
    type: actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_REQUEST
})

const changeLimitSuccess = () => ({
    type: actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_SUCCESS
})

const changeLimitFailure = error => ({
    type: actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_FAILURE,
    payload: {
        error
    }
})

const setNewLimit = (accountId) => (dispatch, getState) => {

    const callback = (dispatch, getState, dataToken) => {
        const immAccount = getState().creditsPregranted.getIn(['byId', accountId]);
        const immCreditPregrantedLimitVariation = getState().creditPregrantedLimitVariation;

        const params = {
            query: {
                tokenFirma: dataToken,
                datosConexion: {
                    contrato: {
                        numerodecontrato: immAccount.get('contractNumber'),
                        producto: immAccount.get('product')
                    }
                },
                datosVariacion: {
                    moneda: immAccount.getIn(['available', 'currency']),
                    nuevoImporteLimite: immCreditPregrantedLimitVariation.get('newLimit'),
                    fechaAlta: immAccount.getIn(['details', 'effectiveDate']),
                    subtipoProducto: {
                        subtipodeproducto: immAccount.get('productSubtype'),
                        tipodeproducto: {
                            tipodeproducto: immAccount.get('newProduct')
                        }
                    },
                    horaModificacion: immAccount.getIn(['details', 'hour']),
                    inicioValidez: immAccount.getIn(['details', 'startingDate']),
                    fecha: immAccount.getIn(['details', 'originalDate']),
                    finValidez: immAccount.getIn(['details', 'originalDate']),
                    fechaActualizacion: immAccount.getIn(['details', 'originalDate']),
                    contratoSeleccionado: {
                        numerodecontrato: immAccount.get('contractNumber'),
                        producto: immAccount.get('product')
                    }
                }
            }
        };

        dispatch(changeLimitRequest());
        APIPost(dispatch, apiURLBuilder.getURL('pregrantedCreditLimitVariation'), params)
            .then(response => dispatch(changeLimitSuccess(response)))
            .catch(error => dispatch(changeLimitFailure(error)));
    };

    return Promise.resolve().then(function () {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    })
}

module.exports = {
    setLimit,
    setVisibleStep,
    validateStep,
    setWillCancel,
    setNewLimit,
    clear
};
